import React from 'react';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import {
    HeaderData,
    DemiText,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import {
    MainContainerItems,
    UsagePricingTableFont,
} from 'src/common/components/orderDetails/detailsDataTable/DetailsDataTable.styled';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import { useTranslation } from 'react-i18next';
import { sizes } from 'src/styles/Media.styled';

export const BackorderDatatable = ({
    data,
    setItemHandler,
    specificPadding,
}) => {
    let colData = [
        {
            field: 'itemDescription',
        },
        {
            field: 'ordered',
        },
        {
            field: 'shipped',
        },

        {
            field: 'backorder',
        },
    ];
    const { t } = useTranslation();
    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        };
        switch (column.field) {
            case 'itemDescription':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>
                            {t(
                                'reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription'
                            )}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: '0.5rem 1rem 0.5rem 0.5rem',
                    width: '40%',
                };
                extraProps.bodyStyle = {
                    padding: '0rem 1rem 0.5rem 0.5rem',
                    width: '40%',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems width={'100%'}>
                            {rowData?.cfn ? (
                                <CfnLabel
                                    setItemHandler={setItemHandler}
                                    setDetailsData={rowData}
                                    cfn={rowData.cfn}
                                    isShowSetItemDetails={true}
                                    cursor={'pointer'}
                                    textAlign={'left'}
                                />
                            ) : null}
                            <ItemDescriptionLabel
                                lineHeight={'19px'}
                                letterSpacing={'-0.1px'}
                                description={rowData.description}
                                fontSize={'13px'}
                            />
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'ordered':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>
                            {t('orders.orderDetails.replenRequest.ordered')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: window.innerWidth>=sizes.smalDevice && 
                            window.innerWidth < sizes.largeDevice ? '0.5rem 0rem' : '0.5rem 0.3rem',
                    width: '20%',
                    textAlign: 'right',
                };
                extraProps.bodyStyle = {
                    textAlign: 'right',
                    width: '20%', 
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            marginBottom={'38px'}
                            width={'100%'}
                            padding={'0rem 0!important'}
                            ipadPadding={'0.5rem 0'}
                            mdPadding={'0rem 0'}
                            ldPadding={'0rem 0'}
                        >
                            <UsagePricingTableFont fontSize={'14px'}>
                                {rowData?.orderedQty ? rowData.orderedQty : 0}
                            </UsagePricingTableFont>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'shipped':
                extraProps.header = (
                    <HeaderData>
                        <DemiText>
                            {t('orders.orderDetails.replenRequest.shipped')}
                        </DemiText>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: window.innerWidth>=sizes.smalDevice && 
                            window.innerWidth < sizes.largeDevice ? '0.5rem 0rem' : '0.5rem 0.3rem',
                    width: '20%',
                    textAlign: 'right',
                };
                extraProps.bodyStyle = {
                    textAlign: 'right',
                    width: '20%', 
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            marginBottom={'38px'}
                            width={'100%'}
                            padding={'0rem 0!important'}
                            ipadPadding={'0.5rem 0'}
                            mdPadding={'0rem 0'}
                            ldPadding={'0rem 0'}
                        >
                            <UsagePricingTableFont fontSize={'14px'}>
                                {rowData?.shippedQty ? rowData.shippedQty : 0}
                            </UsagePricingTableFont>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'backorder':
                extraProps.header = (
                    <HeaderData>
                        <UsagePricingTableFont
                            fontFamily={'AvenirNextWorld Demi'}
                            color={'#ED002A'}
                            fontSize={'13px'}
                        >
                            {t('orders.orderDetails.replenRequest.backOrder')}
                        </UsagePricingTableFont>
                    </HeaderData>
                );
                extraProps.headerStyle = {
                    padding: window.innerWidth>=sizes.smalDevice && 
                        window.innerWidth < sizes.largeDevice ? '0.5rem 2rem' : '0.5rem 2.4rem',
                    width: '25%',
                    textAlign: 'right',
                };
                extraProps.bodyStyle = { 
                    textAlign: 'right',
                    width: '25%',
                    padding: '0 2rem',
                };
                extraProps.body = (rowData) => {
                    return (
                        <MainContainerItems
                            marginBottom={'38px'}
                            width={'100%'}
                            padding={'0rem 0'}
                            ipadPadding={'0.5rem 0'}
                            mdPadding={'0rem 0'}
                            ldPadding={
                                specificPadding
                                    ? specificPadding
                                    : '0rem 2.5rem'
                            }
                        >
                            <UsagePricingTableFont
                                fontSize={'14px'}
                                color={
                                    parseInt(rowData.backOrderQty) > 0
                                        ? '#ED002A'
                                        : '#000000'
                                }
                            >
                                {rowData?.backOrderQty
                                    ? rowData.backOrderQty
                                    : 0}
                            </UsagePricingTableFont>
                        </MainContainerItems>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    return (
        <>
            <Datatable
                id={'orderDetails-details-backorder-datatable'}
                backgroundColorOdd={'#FFFFFF99'}
                backgroundColorEven={'#F5F5F599'}
                resizableColumns
                columns={colData}
                data={data}
                scrollable
                rows={data?.length > 0 ? data.length : 0}
                padding={'2px 0'}
            />
        </>
    );
};

export default BackorderDatatable;
